/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Section_Billing_SummaryInputs */



/**
* | output |
* | --- |
* | "Your offer, the payment, the invoices" |
*
* @param {Account_Section_Billing_SummaryInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const account_section_billing_summary = /** @type {((inputs?: Account_Section_Billing_SummaryInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Section_Billing_SummaryInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Your offer, the payment, the invoices")
	return /** @type {LocalizedString} */ ("Votre offre, le paiement, les factures")
});